import { User } from 'components/sidenav/navbar/navbar';
import { DemoModeMark } from 'components/demo-mode-mark';

import s from './Navbar.module.scss';

export const Navbar = () => (
  <header className={s.container}>
    <div className={s.start}>
      <DemoModeMark />
    </div>
    <User />
  </header>
);
